import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {signInAction, signOutAction} from "../actions/auth_actions";

export default function AuthConnector(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({signInAction, signOutAction}, dispatch);
}

function mapStateToProps(state) {
    return {
        errorMessage: state.auth.error,
        userRole: state.auth.userRole,
        userName: state.auth.userName,
        authenticated: state.auth.authenticated
    };
}



// WEBPACK FOOTER //
// ./src/containers/auth_container.js